import { Blueprint } from 'types';

/**
 * Extracts currency code from blueprint calculations and converts to uppercase format
 * @param blueprintDetails - Blueprint data from API
 * @returns Currency code in uppercase format ('EUR', 'GBP', 'USD') or 'EUR' as fallback
 */
export const getCurrencyFromBlueprint = (blueprintDetails?: Partial<Blueprint>): string => {
  if (!blueprintDetails?.calculations?.length) {
    return 'EUR';
  }

  // Get currency from first calculation (they should all be the same)
  const firstCalculation = blueprintDetails.calculations[0];
  const currencyCode = firstCalculation?.currencyCode || 'eur';

  // Convert to uppercase format expected by CurrencyNumberInput
  return currencyCode.toUpperCase();
};
